import { useContext, useState } from 'react'
import { enqueueSnackbar } from 'notistack'

import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField } from '@mui/material'
import SyncOutlinedIcon from '@mui/icons-material/SyncOutlined'

import { AppContext } from '/providers/app-context'
import { notifyPasses, notifyPass } from '/providers/passes-api'

const NodifySelectedDialog = ({ open, setOpen, template, passes, refresh }) => {

  const { apiSource, apiKeys, processing, setProcessing } = useContext(AppContext)
  const [notification, setNotification] = useState("")
  
  if (!template) return null

  const doSyncPasses = async () => {
    close()
    setProcessing(true)
    enqueueSnackbar({ message: 'Notifying passes', variant: 'light' })

    if (passes.length > 1) {
      const result = await notifyPasses({ apiSource, apiKeys, templateId: template.id, passes, notification })
      if (result.ok){
        enqueueSnackbar({ message: 'Notifications queued', variant: 'success' })
      } else {
        enqueueSnackbar({ message: 'Notification failed', variant: 'error' })
      }
    } else {
      const result = await notifyPass({ apiSource, apiKeys, templateId: template.id, passId:passes[0], notification })
      if (result.ok) {
        enqueueSnackbar({ message: 'Notification sent', variant: 'success' })
        refresh()
      } else {
        enqueueSnackbar({ message: 'Notification failed', variant: 'error' })
      }
    }
    
    setProcessing(false)
    setNotification("")
  }

  const close = () => setOpen(false)

  return (
    <Dialog
      open={open}
      onClose={close}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Notify Selected Passes : {template.name}
      </DialogTitle>

      <DialogContent>
        <div style={{ width: 600 }} className='flex flex-col gap-5'>
          <p>This will send a notification to the selected [{passes.length}] passes.</p>

          <TextField value={notification} label="Notification text" sx={{width:550}} 
            onChange={e => setNotification(e.target.value.substring(0, 255))} 
            slotProps={{ inputLabel: { shrink: true } }}
            autoFocus
            type="search"/>
        </div>
      </DialogContent>
      <DialogActions>
        <div className="flex flex-row justify-between w-full p-5">
          <Button variant="outlined" onClick={close} disabled={processing}>Cancel</Button>
          <Button variant="contained" onClick={doSyncPasses} autoFocus disabled={processing || notification.length < 5}><SyncOutlinedIcon className="mr-5" />Notify Selected Passes</Button>
        </div>
      </DialogActions>
    </Dialog>
  )
}

export default NodifySelectedDialog